@if (showLabel) {
  {{ 'GuidelineEditor.Header.RevisionDate.Label' | transloco }}:
}

{{ _revisionDate | translocoDate }}

@if (isExpired) {
  <mat-icon
    [icon]="'error'"
    [iconSize]="15"
    [ttTooltip]="'GuidelineManage.ManageTable.ExpiredTooltip' | transloco: { date: _revisionDate | translocoDate }" />
} @else if (isExpiring) {
  <mat-icon
    [icon]="'warning'"
    [iconSize]="15"
    [ttTooltip]="'GuidelineManage.ManageTable.ExpiringTooltip' | transloco: { date: _revisionDate | translocoDate }" />
}
